import React, { AnchorHTMLAttributes, ComponentProps } from "react";
import Link from "next/link";

import publicConfig from "config/public";

import Image from "components/Image";

const {
  imgix: { publicUrl },
} = publicConfig;

interface MapCalloutOptions {
  children?: React.ReactNode;
  fadeBottom?: boolean; // controls whether to show the fade-out gradient on the bottom of the map callout
}

const MapCallout: React.FC<
  Pick<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & MapCalloutOptions
> = ({ fadeBottom, children, ...others }) => {
  const href = (others as ComponentProps<typeof Link>).href;
  const Element = href ? Link : "div";

  return (
    <div className="relative map-wrapper">
      <style jsx>{`
        .fadeBottom {
          background-image: linear-gradient(
            180deg,
            transparent 28%,
            #ffffff 57%
          );
          height: 100%;
          width: 100%;
          top: 85px;
        }

        @media (min-height: 768px) {
          .fadeBottom {
            height: 670px;
            top: -56px;
          }
        }

        .map-wrapper {
          height: 400px;
        }

        .map-card {
          position: absolute;
          bottom: 15%;
          left: 0px;
          right: 0px;
          margin-left: 16px;
          margin-right: 16px;
        }
        @media (min-width: 768px) {
          .map-card {
            width: 343px;
            max-width: 343px;
            margin-left: auto;
            margin-right: auto;
          }
        }
      `}</style>
      <style jsx>{`
        .map-banner-map-gradient {
          position: relative;
        }
        .map-banner-map-gradient:after {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0) 40%,
            #ffffff 80%
          );
        }
      `}</style>
      <Element aria-hidden href={href}>
        <Image
          alt=""
          background
          className="map-banner-map-gradient"
          mobileSrc={`${publicUrl}/brands/mso-map/map_mobile.png`}
          sizes={[544, 767, 1023, 1440, null, 767]}
          src={`${publicUrl}/brands/mso-map/map_desktop.png`}
          tabletSrc={`${publicUrl}/brands/mso-map/map_tablet.png`}
        />
        {fadeBottom && <div className="fadeBottom absolute" />}
      </Element>
      <div className="map-card bg-white py-lg px-xl rounded elevation-low text-center">
        {children}
      </div>
    </div>
  );
};

export default MapCallout;
